export default __webpack_public_path__ + "static/media/cf.3eab92ee.svg";